import axios from "axios";

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;

// Public axios instance — no auth required (linktree is accessed before login)
const httpPublic = axios.create({ baseURL: BACKEND_URL });

export type WaiterEventType =
  | "page_view"
  | "google"
  | "tripadvisor"
  | "instagram"
  | "bestiebite"
  | "menu";

/**
 * Fire-and-forget: track a waiter scan event.
 * Errors are silently swallowed — tracking should never break the user flow.
 */
export function trackWaiterEvent(waiterId: number, eventType: WaiterEventType): void {
  httpPublic.post(`/waiters/${waiterId}/track`, { event_type: eventType }).catch(() => {
    // Intentionally silent — tracking must not impact the user experience
  });
}
